import { Container } from '@mui/material';
import { ReactElement } from 'react';
import { useWindowDimensions } from '@vegi.toenlioe/novitate-react-components';

function Dashboard(): ReactElement {
    const {height} = useWindowDimensions();

    return (
        <Container maxWidth="xl">

        </Container>
    );
}

export default Dashboard;
